// Generate code from clean architecture template

import { QueryCoursePayload, QueryCoursesOutput } from '../ports/payloads';
import { CourseRepository } from '../ports/repositories';

export class GetListCourseUsecase {
  constructor(private readonly repo: CourseRepository) {}

  async run(payload?: QueryCoursePayload): Promise<QueryCoursesOutput> {
    const data = await this.repo.getListCourse(payload);
    return data;
  }
}
